export { hasColoredIcon } from './helpers/index.es.js';
export { GenIcon, IconBase, SvgCss } from './helpers/IconBase.es.js';
export { DefaultContext, IconContext } from './helpers/IconContext.es.js';
export { AccountColored } from './components/AccountColored.es.js';
export { AtmCardColored } from './components/AtmCardColored.es.js';
export { AtmColored } from './components/AtmColored.es.js';
export { BadgesColored } from './components/BadgesColored.es.js';
export { BankColored } from './components/BankColored.es.js';
export { CashColored } from './components/CashColored.es.js';
export { CircleBankColored } from './components/CircleBankColored.es.js';
export { CircleCashColored } from './components/CircleCashColored.es.js';
export { CircleMobileBankingColored } from './components/CircleMobileBankingColored.es.js';
export { CircleQrCodeColored } from './components/CircleQrCodeColored.es.js';
export { CircleShippingColored } from './components/CircleShippingColored.es.js';
export { CircleShowroomColored } from './components/CircleShowroomColored.es.js';
export { CircleVisaLogoColored } from './components/CircleVisaLogoColored.es.js';
export { DeleteCircleColored } from './components/DeleteCircleColored.es.js';
export { DinoColored } from './components/DinoColored.es.js';
export { DiscountTagColored } from './components/DiscountTagColored.es.js';
export { EmptySearchColored } from './components/EmptySearchColored.es.js';
export { FireFlashsaleColored } from './components/FireFlashsaleColored.es.js';
export { FreeShippingColored } from './components/FreeShippingColored.es.js';
export { GiftColored } from './components/GiftColored.es.js';
export { GuaranteeCheckedColored } from './components/GuaranteeCheckedColored.es.js';
export { IndicatorColored } from './components/IndicatorColored.es.js';
export { MasterCardColored } from './components/MasterCardColored.es.js';
export { MessengerColored } from './components/MessengerColored.es.js';
export { MobileBankingColored } from './components/MobileBankingColored.es.js';
export { PaymentColored } from './components/PaymentColored.es.js';
export { PvShowroomColored } from './components/PvShowroomColored.es.js';
export { QrCodeColored } from './components/QrCodeColored.es.js';
export { RewardGoldenColored } from './components/RewardGoldenColored.es.js';
export { RewardBronzeCircleColored } from './components/RewardBronzeCircleColored.es.js';
export { RewardBronzeColored } from './components/RewardBronzeColored.es.js';
export { RewardGoldenCircleColored } from './components/RewardGoldenCircleColored.es.js';
export { RewardPlatinumCircleColored } from './components/RewardPlatinumCircleColored.es.js';
export { RewardPlatinumColored } from './components/RewardPlatinumColored.es.js';
export { RewardSilverCircleColored } from './components/RewardSilverCircleColored.es.js';
export { RewardSilverColored } from './components/RewardSilverColored.es.js';
export { SaleColored } from './components/SaleColored.es.js';
export { ShippingColored } from './components/ShippingColored.es.js';
export { ShopColored } from './components/ShopColored.es.js';
export { ShoppingCartColored } from './components/ShoppingCartColored.es.js';
export { StarColored } from './components/StarColored.es.js';
export { SuccessColored } from './components/SuccessColored.es.js';
export { UsaColored } from './components/UsaColored.es.js';
export { VietnamColored } from './components/VietnamColored.es.js';
export { VisaCardColored } from './components/VisaCardColored.es.js';
export { VisaLogoColored } from './components/VisaLogoColored.es.js';
export { VoucherColored } from './components/VoucherColored.es.js';
export { WalletColored } from './components/WalletColored.es.js';
export { DirectionFilled } from './components/DirectionFilled.es.js';
export { AccountFilled } from './components/AccountFilled.es.js';
export { ArrowDownTinyFilled } from './components/ArrowDownTinyFilled.es.js';
export { ArrowDownFilled } from './components/ArrowDownFilled.es.js';
export { ArrowLeftTinyFilled } from './components/ArrowLeftTinyFilled.es.js';
export { ArrowLeftFilled } from './components/ArrowLeftFilled.es.js';
export { ArrowRightTinyFilled } from './components/ArrowRightTinyFilled.es.js';
export { ArrowRightFilled } from './components/ArrowRightFilled.es.js';
export { ArrowUpTinyFilled } from './components/ArrowUpTinyFilled.es.js';
export { ArrowUpFilled } from './components/ArrowUpFilled.es.js';
export { CalendarFilled } from './components/CalendarFilled.es.js';
export { CallFilled } from './components/CallFilled.es.js';
export { CartFilled } from './components/CartFilled.es.js';
export { CautionFilled } from './components/CautionFilled.es.js';
export { ChevronForwardFilled } from './components/ChevronForwardFilled.es.js';
export { ChevronLeftFilled } from './components/ChevronLeftFilled.es.js';
export { ChevronUpFilled } from './components/ChevronUpFilled.es.js';
export { ClockFilled } from './components/ClockFilled.es.js';
export { DeleteCircleFilled } from './components/DeleteCircleFilled.es.js';
export { DiscountTagFilled } from './components/DiscountTagFilled.es.js';
export { DiscountFilled } from './components/DiscountFilled.es.js';
export { DoubleArrowTinyFilled } from './components/DoubleArrowTinyFilled.es.js';
export { DoubleArrowFilled } from './components/DoubleArrowFilled.es.js';
export { EditFilled } from './components/EditFilled.es.js';
export { EyeHideFilled } from './components/EyeHideFilled.es.js';
export { EyeShowFilled } from './components/EyeShowFilled.es.js';
export { FacebookMessengerFilled } from './components/FacebookMessengerFilled.es.js';
export { FacebookFilled } from './components/FacebookFilled.es.js';
export { FacebookSquareFilled } from './components/FacebookSquareFilled.es.js';
export { FavouriteFilled } from './components/FavouriteFilled.es.js';
export { FilterFilled } from './components/FilterFilled.es.js';
export { FlashSaleFilled } from './components/FlashSaleFilled.es.js';
export { FlashOffFilled } from './components/FlashOffFilled.es.js';
export { FlashOnFilled } from './components/FlashOnFilled.es.js';
export { GarbageFilled } from './components/GarbageFilled.es.js';
export { GiftFilled } from './components/GiftFilled.es.js';
export { GlobalFilled } from './components/GlobalFilled.es.js';
export { GoogleFilled } from './components/GoogleFilled.es.js';
export { HighlightBackgroundFilled } from './components/HighlightBackgroundFilled.es.js';
export { HomepageFilled } from './components/HomepageFilled.es.js';
export { ImageFilled } from './components/ImageFilled.es.js';
export { InforFilled } from './components/InforFilled.es.js';
export { LayerFilled } from './components/LayerFilled.es.js';
export { MoreProductFilled } from './components/MoreProductFilled.es.js';
export { NotificationFilled } from './components/NotificationFilled.es.js';
export { OrderFilled } from './components/OrderFilled.es.js';
export { PbCallFilled } from './components/PbCallFilled.es.js';
export { PbInpageLinkFilled } from './components/PbInpageLinkFilled.es.js';
export { PbMailFilled } from './components/PbMailFilled.es.js';
export { PbNavigationCurvedFilled } from './components/PbNavigationCurvedFilled.es.js';
export { PbNavigationRoundFilled } from './components/PbNavigationRoundFilled.es.js';
export { PbPaginationDotBigFilled } from './components/PbPaginationDotBigFilled.es.js';
export { PbPaginationDotLineFilled } from './components/PbPaginationDotLineFilled.es.js';
export { PbPaginationDotsFilled } from './components/PbPaginationDotsFilled.es.js';
export { PbPaginationLineFilled } from './components/PbPaginationLineFilled.es.js';
export { PbSliderOneRowFilled } from './components/PbSliderOneRowFilled.es.js';
export { PbSliderThreeRowFilled } from './components/PbSliderThreeRowFilled.es.js';
export { PbSliderTwoRowFilled } from './components/PbSliderTwoRowFilled.es.js';
export { PhoneFilled } from './components/PhoneFilled.es.js';
export { ProfileFilled } from './components/ProfileFilled.es.js';
export { PromoFilled } from './components/PromoFilled.es.js';
export { RatingFilled } from './components/RatingFilled.es.js';
export { ShareFilled } from './components/ShareFilled.es.js';
export { ShoppingCartFilled } from './components/ShoppingCartFilled.es.js';
export { SliderFilled } from './components/SliderFilled.es.js';
export { SuccessFilled } from './components/SuccessFilled.es.js';
export { TickFilled } from './components/TickFilled.es.js';
export { VoucherFilled } from './components/VoucherFilled.es.js';
export { YoutubeFilled } from './components/YoutubeFilled.es.js';
export { ZaloFilled } from './components/ZaloFilled.es.js';
export { AddAlternativeOutlined } from './components/AddAlternativeOutlined.es.js';
export { ClockAlternativeOutlined } from './components/ClockAlternativeOutlined.es.js';
export { DirectionAlternativeOutlined } from './components/DirectionAlternativeOutlined.es.js';
export { FavouriteAlternativeOutlined } from './components/FavouriteAlternativeOutlined.es.js';
export { FormScaleAlternativeOutlined } from './components/FormScaleAlternativeOutlined.es.js';
export { HomepageAlternativeOutlined } from './components/HomepageAlternativeOutlined.es.js';
export { LaptopAlternativeOutlined } from './components/LaptopAlternativeOutlined.es.js';
export { MarkAsReadAlternativeOutlined } from './components/MarkAsReadAlternativeOutlined.es.js';
export { RatingAlternativeOutlined } from './components/RatingAlternativeOutlined.es.js';
export { SettingAlternativeOutlined } from './components/SettingAlternativeOutlined.es.js';
export { SuccessAlternativeOutlined } from './components/SuccessAlternativeOutlined.es.js';
export { AccountOutlined } from './components/AccountOutlined.es.js';
export { AddItemOutlined } from './components/AddItemOutlined.es.js';
export { AddOutlined } from './components/AddOutlined.es.js';
export { AdvisoryOutlined } from './components/AdvisoryOutlined.es.js';
export { AlignCenterOutlined } from './components/AlignCenterOutlined.es.js';
export { AlignJustifyOutlined } from './components/AlignJustifyOutlined.es.js';
export { AlignLeftOutlined } from './components/AlignLeftOutlined.es.js';
export { AlignRightOutlined } from './components/AlignRightOutlined.es.js';
export { BackToTopOutlined } from './components/BackToTopOutlined.es.js';
export { BackOutlined } from './components/BackOutlined.es.js';
export { BagCheckmarkOutlined } from './components/BagCheckmarkOutlined.es.js';
export { BoldOutlined } from './components/BoldOutlined.es.js';
export { BoxOutlined } from './components/BoxOutlined.es.js';
export { BriefCaseOutlined } from './components/BriefCaseOutlined.es.js';
export { BuildPcOutlined } from './components/BuildPcOutlined.es.js';
export { BulletedListOutlined } from './components/BulletedListOutlined.es.js';
export { BusinessCustomerOutlined } from './components/BusinessCustomerOutlined.es.js';
export { BusinessSolutionOutlined } from './components/BusinessSolutionOutlined.es.js';
export { ButtonOutlined } from './components/ButtonOutlined.es.js';
export { CalculatorOutlined } from './components/CalculatorOutlined.es.js';
export { CalendarOutlined } from './components/CalendarOutlined.es.js';
export { CameraOutlined } from './components/CameraOutlined.es.js';
export { CartOutlined } from './components/CartOutlined.es.js';
export { CashOutlined } from './components/CashOutlined.es.js';
export { CautionOutlined } from './components/CautionOutlined.es.js';
export { ChatOutlined } from './components/ChatOutlined.es.js';
export { CheckOutlined } from './components/CheckOutlined.es.js';
export { ChecklistOutlined } from './components/ChecklistOutlined.es.js';
export { ChipOutlined } from './components/ChipOutlined.es.js';
export { CircleBackOutlined } from './components/CircleBackOutlined.es.js';
export { CircleDownOutlined } from './components/CircleDownOutlined.es.js';
export { CircleForwardOutlined } from './components/CircleForwardOutlined.es.js';
export { CircleUpOutlined } from './components/CircleUpOutlined.es.js';
export { CloseOutlined } from './components/CloseOutlined.es.js';
export { CopyOutlined } from './components/CopyOutlined.es.js';
export { CustomerSupportOutlined } from './components/CustomerSupportOutlined.es.js';
export { DinoOutlined } from './components/DinoOutlined.es.js';
export { DiscountTagOutlined } from './components/DiscountTagOutlined.es.js';
export { DiscountOutlined } from './components/DiscountOutlined.es.js';
export { DividerOutlined } from './components/DividerOutlined.es.js';
export { DocumentOutlined } from './components/DocumentOutlined.es.js';
export { DotOutlined } from './components/DotOutlined.es.js';
export { DownLineOutlined } from './components/DownLineOutlined.es.js';
export { DownOutlined } from './components/DownOutlined.es.js';
export { DownloadOutlined } from './components/DownloadOutlined.es.js';
export { DragOutlined } from './components/DragOutlined.es.js';
export { DragdropOutlined } from './components/DragdropOutlined.es.js';
export { DuplicateOutlined } from './components/DuplicateOutlined.es.js';
export { EditColumnOutlined } from './components/EditColumnOutlined.es.js';
export { EditSquareOutlined } from './components/EditSquareOutlined.es.js';
export { EditOutlined } from './components/EditOutlined.es.js';
export { EndShiftOutlined } from './components/EndShiftOutlined.es.js';
export { ExportStockOutlined } from './components/ExportStockOutlined.es.js';
export { ExportFileOutlined } from './components/ExportFileOutlined.es.js';
export { EyeOutlined } from './components/EyeOutlined.es.js';
export { FaceIdOutlined } from './components/FaceIdOutlined.es.js';
export { FileOutlined } from './components/FileOutlined.es.js';
export { FillColorShapeOutlined } from './components/FillColorShapeOutlined.es.js';
export { FillColorTextOutlined } from './components/FillColorTextOutlined.es.js';
export { FilterOutlined } from './components/FilterOutlined.es.js';
export { FingerPrintOutlined } from './components/FingerPrintOutlined.es.js';
export { FormOutlined } from './components/FormOutlined.es.js';
export { FormatTextLeftOutlined } from './components/FormatTextLeftOutlined.es.js';
export { FormatTextRightOutlined } from './components/FormatTextRightOutlined.es.js';
export { ForwardOutlined } from './components/ForwardOutlined.es.js';
export { GamingOutlined } from './components/GamingOutlined.es.js';
export { GarbageOutlined } from './components/GarbageOutlined.es.js';
export { GoldOutlined } from './components/GoldOutlined.es.js';
export { GuaranteeCheckedOutlined } from './components/GuaranteeCheckedOutlined.es.js';
export { HamburgerOutlined } from './components/HamburgerOutlined.es.js';
export { HeadingOutlined } from './components/HeadingOutlined.es.js';
export { HeadphoneOutlined } from './components/HeadphoneOutlined.es.js';
export { HideOutlined } from './components/HideOutlined.es.js';
export { HOneOutlined } from './components/HOneOutlined.es.js';
export { HThreeOutlined } from './components/HThreeOutlined.es.js';
export { HTwoOutlined } from './components/HTwoOutlined.es.js';
export { IdCardOutlined } from './components/IdCardOutlined.es.js';
export { ImageOutlined } from './components/ImageOutlined.es.js';
export { ImportStockOutlined } from './components/ImportStockOutlined.es.js';
export { InforOutlined } from './components/InforOutlined.es.js';
export { InstallmentOutlined } from './components/InstallmentOutlined.es.js';
export { InstallmentCalendarOutlined } from './components/InstallmentCalendarOutlined.es.js';
export { InternetOutlined } from './components/InternetOutlined.es.js';
export { ItalicOutlined } from './components/ItalicOutlined.es.js';
export { JumpForwardOutlined } from './components/JumpForwardOutlined.es.js';
export { JumpBackOutlined } from './components/JumpBackOutlined.es.js';
export { JumpForwardAlternativeOutlined } from './components/JumpForwardAlternativeOutlined.es.js';
export { LeftLineOutlined } from './components/LeftLineOutlined.es.js';
export { LeftOutlined } from './components/LeftOutlined.es.js';
export { LineOutlined } from './components/LineOutlined.es.js';
export { LineDashedOutlined } from './components/LineDashedOutlined.es.js';
export { LineDottedOutlined } from './components/LineDottedOutlined.es.js';
export { LineThroughOutlined } from './components/LineThroughOutlined.es.js';
export { LinkOutlined } from './components/LinkOutlined.es.js';
export { ListLocationOutlined } from './components/ListLocationOutlined.es.js';
export { LocationOutlined } from './components/LocationOutlined.es.js';
export { LockOutlined } from './components/LockOutlined.es.js';
export { LogOutOutlined } from './components/LogOutOutlined.es.js';
export { LoyaltyOutlined } from './components/LoyaltyOutlined.es.js';
export { MailOutlined } from './components/MailOutlined.es.js';
export { MenuOutlined } from './components/MenuOutlined.es.js';
export { MinusCircleOutlined } from './components/MinusCircleOutlined.es.js';
export { MinusRetangleOutlined } from './components/MinusRetangleOutlined.es.js';
export { MinusOutlined } from './components/MinusOutlined.es.js';
export { MobileAndDesktopOutlined } from './components/MobileAndDesktopOutlined.es.js';
export { MobiphoneOutlined } from './components/MobiphoneOutlined.es.js';
export { MoneyTransferOutlined } from './components/MoneyTransferOutlined.es.js';
export { MonitorOutlined } from './components/MonitorOutlined.es.js';
export { MoreInforOutlined } from './components/MoreInforOutlined.es.js';
export { MoreProductOutlined } from './components/MoreProductOutlined.es.js';
export { NewsOutlined } from './components/NewsOutlined.es.js';
export { NoneOutlined } from './components/NoneOutlined.es.js';
export { NotificationsOutlined } from './components/NotificationsOutlined.es.js';
export { NumberedListOutlined } from './components/NumberedListOutlined.es.js';
export { OrderOutlined } from './components/OrderOutlined.es.js';
export { PageOutlined } from './components/PageOutlined.es.js';
export { ParagraphOutlined } from './components/ParagraphOutlined.es.js';
export { PauseOutlined } from './components/PauseOutlined.es.js';
export { PaymentOutlined } from './components/PaymentOutlined.es.js';
export { PbArrowLeftOutlined } from './components/PbArrowLeftOutlined.es.js';
export { PbLinkOutlined } from './components/PbLinkOutlined.es.js';
export { PbUnlinkOutlined } from './components/PbUnlinkOutlined.es.js';
export { PcOutlined } from './components/PcOutlined.es.js';
export { PhoneOutlined } from './components/PhoneOutlined.es.js';
export { PlayOutlined } from './components/PlayOutlined.es.js';
export { PlusCircleOutlined } from './components/PlusCircleOutlined.es.js';
export { PlusRetangleOutlined } from './components/PlusRetangleOutlined.es.js';
export { PrinterOutlined } from './components/PrinterOutlined.es.js';
export { ProductOutlined } from './components/ProductOutlined.es.js';
export { ProfileOutlined } from './components/ProfileOutlined.es.js';
export { PromoOutlined } from './components/PromoOutlined.es.js';
export { PromoDiscountOutlined } from './components/PromoDiscountOutlined.es.js';
export { QaOutlined } from './components/QaOutlined.es.js';
export { QrCodeScanOutlined } from './components/QrCodeScanOutlined.es.js';
export { RamOutlined } from './components/RamOutlined.es.js';
export { RedoOutlined } from './components/RedoOutlined.es.js';
export { RefreshOutlined } from './components/RefreshOutlined.es.js';
export { RefundOutlined } from './components/RefundOutlined.es.js';
export { ReturnItemOutlined } from './components/ReturnItemOutlined.es.js';
export { RightLineOutlined } from './components/RightLineOutlined.es.js';
export { RightOutlined } from './components/RightOutlined.es.js';
export { SaveOutlined } from './components/SaveOutlined.es.js';
export { ScanningOutlined } from './components/ScanningOutlined.es.js';
export { SearchOutlined } from './components/SearchOutlined.es.js';
export { ShareOutlined } from './components/ShareOutlined.es.js';
export { ShieldOutlined } from './components/ShieldOutlined.es.js';
export { ShippingOutlined } from './components/ShippingOutlined.es.js';
export { ShopOutlined } from './components/ShopOutlined.es.js';
export { ShoppingCartOutlined } from './components/ShoppingCartOutlined.es.js';
export { ShortingOutlined } from './components/ShortingOutlined.es.js';
export { ShowOutlined } from './components/ShowOutlined.es.js';
export { ShowroomOutlined } from './components/ShowroomOutlined.es.js';
export { SpacerOutlined } from './components/SpacerOutlined.es.js';
export { SpeakerOutlined } from './components/SpeakerOutlined.es.js';
export { StopOutlined } from './components/StopOutlined.es.js';
export { SwitchOutlined } from './components/SwitchOutlined.es.js';
export { SyncOutlined } from './components/SyncOutlined.es.js';
export { TelephoneOutlined } from './components/TelephoneOutlined.es.js';
export { TiviOutlined } from './components/TiviOutlined.es.js';
export { TransactionHistoryOutlined } from './components/TransactionHistoryOutlined.es.js';
export { TrashBinDeleteRemoveOutlined } from './components/TrashBinDeleteRemoveOutlined.es.js';
export { TreeviewOutlined } from './components/TreeviewOutlined.es.js';
export { TvNewOutlined } from './components/TvNewOutlined.es.js';
export { UnderlineOutlined } from './components/UnderlineOutlined.es.js';
export { UndoOutlined } from './components/UndoOutlined.es.js';
export { UnionOutlined } from './components/UnionOutlined.es.js';
export { UnionPaymentOutlined } from './components/UnionPaymentOutlined.es.js';
export { UnlinkOutlined } from './components/UnlinkOutlined.es.js';
export { UnlockOutlined } from './components/UnlockOutlined.es.js';
export { UpLineOutlined } from './components/UpLineOutlined.es.js';
export { UpOutlined } from './components/UpOutlined.es.js';
export { UploadOutlined } from './components/UploadOutlined.es.js';
export { VoucherOutlined } from './components/VoucherOutlined.es.js';
export { WarehouseOutlined } from './components/WarehouseOutlined.es.js';
export { WashingOutlined } from './components/WashingOutlined.es.js';
export { WebcamOutlined } from './components/WebcamOutlined.es.js';
